export interface PromiseCallbacks<T> {
  resolve: (value: T) => void;
  reject: (reason?: any) => void;
}

export function createCompletionSource<T>() : ICompletionSource<T> {
  let resolveCallback: (value: T) => void|undefined;
  let rejectCallback: (reason: any) => void|undefined;
  let completed = false;
  const promise = new Promise<T>((resolve, reject) => {
    resolveCallback = resolve;
    rejectCallback = reject;
  });

  function resolve(value: T) {
    setCompleted();
    resolveCallback(value);
  }

  function reject(reason: any) {
    setCompleted();
    rejectCallback(reason);
  }

  function setCompleted() {
    if (completed) throw new Error('Already completed!');
    completed = true;
  }

  return {
    get promise() {
      return promise;
    },
    get completed() {
      return completed;
    },
    resolve,
    reject
  }
}

export interface ICompletionSource<T> {
  readonly promise: Promise<T>;
  readonly completed: boolean;
  resolve: (value: T) => void;
  reject: (reason: any) => void;
}
